









	import Vue from 'vue';

    export default Vue.extend({
        name: "RaidToolbarComp",
        methods: {
            back: function(): void {
                window.history.back();
            },
            toRaidDashboard: function(): void {
                this.$router.push('/raids');
                this.$router.push('/raid');
            }
        },
        computed: {
            raidName: function(): string {
                if (this.$vStore.getters.raid) {
					return this.$vStore.getters.raid.name;
				}
                else {
					return '';
				}
            }
        }
    })
